import React from 'react';
import {
  khachHangSearchColumns,
  khoHangSearchColumns,
  loaiVatTuSearchColumns,
  nhomColumns,
  nhomKhachHangSearchColumns,
  vatTu1SearchColumns
} from '@/constants';
import { FormField, SearchField } from '@/components/custom/erp';
import { QUERY_KEYS } from '@/constants/query-keys';
import { Label } from '@/components/ui/label';

interface DetailsTabProps {
  searchFieldStates?: MuaHangRecord;
}

const DetailsTab: React.FC<DetailsTabProps> = ({ searchFieldStates }) => {
  return (
    <div className='w-full min-w-0 space-y-4 p-4'>
      <div className='flex flex-col space-y-3'>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã nhà cung cấp:</Label>
          <div className='w-[460px]'>
            <SearchField
              searchEndpoint={`/${QUERY_KEYS.KHACH_HANG}/`}
              searchColumns={khachHangSearchColumns}
              dialogTitle='Danh mục khách hàng'
              columnDisplay='customer_code'
              displayRelatedField='customer_name'
              value={searchFieldStates?.customer?.customer_code || ''}
              relatedFieldValue={searchFieldStates?.customer?.customer_name || ''}
              className='w-full'
              classNameRelatedField='w-auto min-w-[300px] max-w-full'
              onRowSelection={(row: MuaHangRecord) => {
                searchFieldStates?.setCustomer(row);
              }}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Nhóm NCC:</Label>
          <div className='w-[448px]'>
            <div className='grid grid-cols-3 gap-x-4'>
              <div className='w-full'>
                <SearchField
                  searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC1`}
                  searchColumns={nhomColumns}
                  dialogTitle='Danh mục nhóm khách hàng 1'
                  columnDisplay='ma_nhom'
                  className='w-full'
                />
              </div>
              <div className='w-full'>
                <SearchField
                  searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC2`}
                  searchColumns={nhomColumns}
                  dialogTitle='Danh mục nhóm khách hàng 2'
                  columnDisplay='ma_nhom'
                  className='w-full'
                />
              </div>
              <div className='w-full'>
                <SearchField
                  searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=NCC3`}
                  searchColumns={nhomColumns}
                  dialogTitle='Danh mục nhóm khách hàng 3'
                  columnDisplay='ma_nhom'
                  className='w-full'
                />
              </div>
            </div>
          </div>
        </div>

        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã vật tư:</Label>
          <div className='w-[460px]'>
            <SearchField
              searchEndpoint={`/${QUERY_KEYS.VAT_TU}/`}
              searchColumns={vatTu1SearchColumns}
              dialogTitle='Vật tư'
              columnDisplay='ma_vt'
              displayRelatedField='ten_vt'
              value={searchFieldStates?.material?.ma_vt || ''}
              relatedFieldValue={searchFieldStates?.material?.ten_vt || ''}
              className='w-full'
              classNameRelatedField='w-auto min-w-[300px] max-w-full'
              onRowSelection={(row: MuaHangRecord) => {
                searchFieldStates?.setMaterial(row);
              }}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Loại vật tư:</Label>
          <div className='w-[460px]'>
            <SearchField
              searchEndpoint={`/${QUERY_KEYS.LOAI_VAT_TU}/`}
              searchColumns={loaiVatTuSearchColumns}
              dialogTitle='Vật tư'
              columnDisplay='ma_lvt'
              displayRelatedField='ten_lvt'
              value={searchFieldStates?.materialType?.ma_lvt || ''}
              relatedFieldValue={searchFieldStates?.materialType?.ten_lvt || ''}
              className='w-full'
              classNameRelatedField='w-auto min-w-[300px] max-w-full'
              onRowSelection={(row: MuaHangRecord) => {
                searchFieldStates?.setMaterialType(row);
              }}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Nhóm vật tư:</Label>
          <div className='w-[448px]'>
            <div className='grid grid-cols-3 gap-x-4'>
              <div className='w-full'>
                <SearchField
                  searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=VT1`}
                  searchColumns={nhomColumns}
                  dialogTitle='Danh mục nhóm vật tư 1'
                  columnDisplay='ma_nhom'
                  className='w-full'
                />
              </div>
              <div className='w-full'>
                <SearchField
                  searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=VT2`}
                  searchColumns={nhomColumns}
                  dialogTitle='Danh mục nhóm vật tư 2'
                  columnDisplay='ma_nhom'
                  className='w-full'
                />
              </div>
              <div className='w-full'>
                <SearchField
                  searchEndpoint={`/${QUERY_KEYS.NHOM}/?loai_nhom=VT3`}
                  searchColumns={nhomColumns}
                  dialogTitle='Danh mục nhóm vật tư 3'
                  columnDisplay='ma_nhom'
                  className='w-full'
                />
              </div>
            </div>
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mã kho:</Label>
          <div className='w-[460px]'>
            <SearchField
              searchEndpoint={`/${QUERY_KEYS.KHO_HANG}/`}
              searchColumns={khoHangSearchColumns}
              dialogTitle='Kho hàng'
              columnDisplay='ma_kho'
              displayRelatedField='ten_kho'
              value={searchFieldStates?.warehouse?.ma_kho || ''}
              relatedFieldValue={searchFieldStates?.warehouse?.ten_kho || ''}
              className='w-full'
              classNameRelatedField='w-auto min-w-[300px] max-w-full'
              onRowSelection={(row: MuaHangRecord) => {
                searchFieldStates?.setWarehouse(row);
              }}
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Hạn giao hàng:</Label>
          <div className='w-32'>
            <FormField name='ngay_giao' type='date' className='w-[150px]' />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Trạng thái:</Label>
          <div className='w-64'>
            <FormField
              name='status'
              type='select'
              options={[
                { value: 'all', label: 'Tất cả' },
                { value: '0', label: 'Lập chứng từ' },
                { value: '1', label: 'Chờ duyệt' },
                { value: '4', label: 'Đang duyệt' },
                { value: '5', label: 'Đã duyệt' },
                { value: '6', label: 'Đang thực hiện' },
                { value: '7', label: 'Hoàn thành' },
                { value: '9', label: 'Đóng' }
              ]}
              className='w-full'
            />
          </div>
        </div>
        <div className='flex items-center'>
          <Label className='w-40 min-w-40 text-left'>Mẫu báo cáo:</Label>
          <div className='w-1/2'>
            <FormField
              name='mau_bc'
              type='select'
              options={[
                { value: 10, label: 'Mẫu số lượng' },
                { value: 20, label: 'Mẫu số lượng và giá trị' },
                { value: 30, label: 'Mẫu số lượng và giá trị ngoại tệ' }
              ]}
              className='w-full'
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsTab;
